/** DB BIGINT and JSON payloads may surface ids as strings — coerce to positive safe integers. */
export function toPositiveIntId(value: unknown): number | undefined {
    if (typeof value === 'number' && Number.isFinite(value)) {
        const n = Math.trunc(value);
        return n >= 1 && Number.isSafeInteger(n) ? n : undefined;
    }
    if (typeof value === 'string' && value.trim() !== '') {
        const n = parseInt(value.trim(), 10);
        return Number.isFinite(n) && n >= 1 && Number.isSafeInteger(n) ? n : undefined;
    }
    if (typeof value === 'bigint') {
        const n = Number(value);
        return Number.isFinite(n) && n >= 1 && Number.isSafeInteger(n) ? n : undefined;
    }
    return undefined;
}
